<template>
  <div class="sidebarGroup">
    <div class="groupCountainer" v-if="this.isUp">
      <div class="dropdownGroupHidden" :class="{ dropdownGroup: isOpen }">
        <slot />
      </div>
    </div>
    <div
      class="headerGroup"
      @click="handleOpenDropdown"
      :class="{ active: isActive }"
    >
      <div class="iconGroup">
        <b-icon pack="fas" :icon="icon"></b-icon>
      </div>
      <div class="groupNameHovered">
        {{ this.name }}
        <div class="arrow">
          <b-icon
            pack="fas"
            icon="chevron-down"
            class="arrowDown"
            :class="{ arrowUp: isOpen }"
          ></b-icon>
        </div>
      </div>
    </div>
    <div class="groupCountainer" v-if="!this.isUp">
      <div class="dropdownGroupHidden" :class="{ dropdownGroup: isOpen }">
        <slot />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    icon: {
      type: String
    },
    name: {
      type: String
    },
    isUp: {
      type: Boolean
    },
    routes: {
      type: Array
    }
  },
  data() {
    return {
      isOpen: false,
      isActive: false
    };
  },
  methods: {
    handleOpenDropdown() {
      this.isOpen = !this.isOpen;
      this.$store.state.activeGroup = this.name;
    }
  },
  computed: {
    openGroup() {
      return this.$store.state.activeGroup;
    }
  },
  watch: {
    $route({ path }, from) {
      if (this.routes.find(el => el == path)) {
        this.isActive = true;
      } else {
        this.isActive = false;
      }
    },
    openGroup(newGroup) {
      if (newGroup != this.name) {
        this.isOpen = false;
      }
    }
  }
};
</script>

<style>
.active::after {
  content: "";
  position: absolute;
  left: 0;
  width: 5px;
  height: 20px;
  margin-top: 3px;
  background-color: #f56618;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}

.sidebarGroup {
  display: flex;
  flex-direction: column;
}
.iconGroup {
  padding: 0px 10px 0px 0px;
}
.headerGroup {
  color: white;
  width: 90%;
  cursor: pointer;
  padding: 7px 10px;
  margin: 10px 5px;
  display: flex;
  flex-direction: row;
  justify-content: start;
  transition: color 0.2s;
  transition: padding 0.2s;
}
.headerGroup:hover {
  color: #f56618;
  padding: 7px 0px 7px 15px;
}
.groupNameHovered {
  visibility: hidden;
  opacity: 0;
  width: 90%;
  display: flex;
  justify-content: space-between;
  transition: opacity 0.5s;
}

.sidebar:hover .groupNameHovered {
  visibility: visible;
  opacity: 1;
  width: 90%;
  display: flex;
  justify-content: space-between;
}

.dropdownGroupHidden {
  max-height: 0;
  visibility: hidden;
  background-color: #575757;
  transition: max-height 0.4s;
}
.dropdownGroup {
  transition: max-height 0.4s;
  height: auto;
  max-height: 200px;
  visibility: visible;
  background-color: #575757;
  align-self: center;
  padding: 0px 10px;
  border-left: 3px solid #f56618;
}
.dropdownGroup ul li a {
  color: white;
}
.dropdownGroup ul li a:hover {
  color: #f56618;
}

.arrowDown {
  font-size: 10px;
  transition: 0.2s linear;
}
.arrowUp {
  transform: rotate(180deg);
  transition: 0.2s linear;
}
</style>



// WEBPACK FOOTER //
// src/components/custom/sidebar/sidebarGroup.vue